/* global Eht */
import { Quick } from '@bag'

class QuickPanel {
  constructor(opt) {
    const def = {
      selector: 'body',
      slot: [
        {
          name: 'approval',
          icon: 'pencil-square-o',
          show: false,
          shape: 'primary',
          textContent: '审批',
        },
        {
          name: 'save',
          icon: 'floppy-o',
          shape: 'primary',
          textContent: '保存',
        },
      ],
    }
    this.opt = Object.assign(def, opt)
    this.$el = $(this.opt.selector)
    this.init()
  }

  init() {
    const quick = (this.quick = new Quick(this.opt))
    this.unit = quick.unit
    this.$el.append(quick.unit)
    this.buttons = quick.buttons
  }

  hideBtn(...res) {
    this.quick.hideBtn(...res)
  }

  showBtn(...res) {
    this.quick.showBtn(...res)
  }
}

Eht.QuickPanel = QuickPanel

export default QuickPanel
